import React, { useState, useEffect } from "react";

import { useHistory, Link, useParams, useLocation } from "react-router-dom";

import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import CardIcon from "@material-ui/icons/CreditCard";
import HistoryIcon from "@material-ui/icons/HistoryOutlined";
import WalletIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
import DealIcon from "@material-ui/icons/LocalOfferOutlined";


const BottomNav = ({isDealerMerchant}) => {
  let { op } = useParams();
  const page = useLocation();
  const [currentLink, setCurrentLink] = useState(0);

  useEffect(() => {
    if (page.pathname.includes("deals")) {
      setCurrentLink(0);
    } else if (page.pathname.includes("invoices")) {
      setCurrentLink();
    } else if (page.pathname.includes("history")) {
      setCurrentLink(2);
    } else if (page.pathname.includes("wallet")) {
      setCurrentLink(3);
    }
    // console.log(page);
  }, [page]);

  const xLang = (string) => {
		return string
	}

  return (
    <div className="bottom-nav-wrapper">
      <BottomNavigation
        value={currentLink}
        showLabels
        style={{ width: "100%" }}
      >
        {
          isDealerMerchant && 

         <BottomNavigationAction
          component={Link}
          to={`/${op}/deals`}
          label={xLang("Deals")}
          icon={<DealIcon />}
        />
        }
        {
          !isDealerMerchant &&
        <BottomNavigationAction
          component={Link}
          to={`/${op}/invoices`}
          label={xLang("Invoices")}
          icon={<CardIcon />}
        />
        }
        <BottomNavigationAction
          component={Link}
          to={`/${op}/history`}
          label={xLang("History")}
          icon={<HistoryIcon />}
        />
        <BottomNavigationAction
          component={Link}
          to={`/${op}/wallet`}
          label={xLang("Wallet")}
          icon={<WalletIcon />}
        />
      </BottomNavigation>
    </div>
  );
};

export default BottomNav;
